<template>
  <div id="app" class="page-wrapper">
    <AppHeader></AppHeader>
    <div class="page-body">
      <transition
        v-on:before-enter="beforeEnter"
        v-on:enter="enter"
        v-on:after-enter="afterEnter"
        v-on:enter-cancelled="enterCancelled"

        v-on:before-leave="beforeLeave"
        v-on:leave="leave"
        v-on:after-leave="afterLeave"
        v-on:leave-cancelled="leaveCancelled"
      >
        <router-view></router-view>
      </transition>
    </div>
    <AppFooter></AppFooter>
  </div>

</template>

<script>
  import AppHeader from './Header.vue'
  import AppFooter from './Footer.vue'
  import { TimelineMax, CSSPlugin, ScrollToPlugin, Draggable } from "gsap/all"
  import _ from 'lodash'


  import homePage from '../pages/Home.vue'
  import introPage from '../pages/Intro.vue'
  import contactPage from '../pages/Contact.vue'
  import GalleryPage from '../pages/Gallery.vue'

  import Mq from 'fine-mq/dist/mq'

  export default {
    name: 'AppLayout',
    components: {
      AppHeader,
      AppFooter,
      homePage,
      introPage,
      contactPage,
      GalleryPage
    },
    data: function() {
      return {
        pages:[
          'index',
          'intro',
          'portfolio',
          'contact'
        ],
        currentpage: null,
        /*
		   * Amount of space between top of screen and the section to highlight
		   */
        offset: 52,
        clickToScroll: true,
        duration: 600,
        modifyUrl: true,
        /*
		    * Must be a string with 4 values seperated by commas
		    */
        bezierEasingValue: '.5,0,.35,1',
        observer: null,
        items: [],
        currentItem: null,
        lastActiveItem: null,
        scrollAnimationFrame: null,
        lastKnowScrollY: 0,
        currentScrollY: 0,
        ticking: false,
        idOfHeader: 'header',
        eleHeader: null,
        window: null,
        app: null,
        logo: null,
        wrapper: null,
        isVisible: false,
        firstScreen: null,
        timeLineIn: null,
        timeLineOut: null,
        screens: [],
        screen: null,
        screenNav: null,
        screenId: null,
        screenIndex: null,
        nav: null
      }
    },
    mounted () {

    },
    created () {
    },
    updated () {
    },
    watch: {
      '$route': 'animateIn'
    },
    methods: {

      animateIn() {
        let title = document.querySelector('.page-title');
        let headline = document.querySelector('.page-headline');
        let text = document.querySelector('.page-text');
        let media = document.querySelector('.page-media');
        // let bgColor = screen.getAttribute('data-bg-color');
        // let bg = screen.querySelector('.slide-bg');
        // bg.style.backgroundColor = bgColor;
        let timeLineIn = (new TimelineMax()
          .add(this.addTitle(title), 'start')
          .add(this.addHeadline(headline), 'start+=.3')
          .add(this.addText(text),'start+=.4'))
          .add(this.addMedia(media), 'start +=.5');

      },
      addMedia(screen) {
        let tl = new TimelineMax();
        tl.fromTo(screen, 1, {
          autoAlpha: 0,
          x: '+100%'
        }, {
          autoAlpha: 1,
          x: '0%',
          ease: Power3.easeOut
        });
        return tl;
      },
      addText(screen) {
        let tl = new TimelineMax();
        tl.fromTo(screen, 1, {
          y: '-50%',
          opacity: 0,
        }, {
          y: '0%',
          opacity: 1,
          ease: Power3.easeOut,
        });
        return tl;
      },
      addTitle(screen) {
        let tl = new TimelineMax();
        tl.fromTo(screen, 1, {
          y: '-50%',
          opacity: 0,
        }, {
          y: '0%',
          opacity: 1,
          ease: Power3.easeOut,
        });
        return tl;
      },
      addHeadline(screen) {
        let tl = new TimelineMax();
        tl.fromTo(screen, 1, {
          y: '-50%',
          opacity: 0,
        }, {
          y: '0%',
          opacity: 1,
          ease: Power3.easeOut,
        });
        return tl;
      },
      // --------
      // ENTERING
      // --------

      beforeEnter: function (el) {
        // ...
        // el.style.opacity = 0;
        // el.style.translateY = "-50%";
      },
      // the done callback is optional when
      // used in combination with CSS
      enter: function (el, done) {
        // ...
        // el.style.opacity = 1;
        // this.animateIn();
        // done()
      },
      afterEnter: function (el) {
        // ...

      },
      enterCancelled: function (el) {
        // ...
      },

      // --------
      // LEAVING
      // --------

      beforeLeave: function (el) {
        // ...
      },
      // the done callback is optional when
      // used in combination with CSS
      leave: function (el, done) {
        // ...
        done()
      },
      afterLeave: function (el) {
        // ...
      },
      // leaveCancelled only available with v-show
      leaveCancelled: function (el) {
        // ...
      }
    }
  }
</script>


<style lang="scss">
  .page-content {
    /*z-index: 1;*/
    /*position: relative;*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*height: auto;*/
    /*margin: 5% 0;*/
    /*overflow-y: hidden;*/
  }

  .headline-dot {
    display: inline-block;
    height: .75rem;
    border-radius: 50%;
    background: $prime-color;
    width: .75rem;
  }

  .page-title {
    font-weight: 700;
    color: $prime-color;
    position: relative;

    @include media_desktop {
      padding-left: 1.75rem;
    }

    @include media_tablet {
      padding-left: 2.75rem;
    }

    &:before {
      content: '';
      background: $prime-color;
      display: block;
      position: absolute;
      left: 0;

      @include media_desktop {
        bottom: 1rem;
        height: .3rem;
        width: 1rem;
      }

      @include media_tablet {
        bottom: 2rem;
        height: .4rem;
        width: 2rem;
      }
    }
  }

  .page-media {
    padding: 5%;
    z-index: 1;
  }

  .swiper-pagination-bullet-active {
    background: $prime-color !important;
    box-shadow: $card-shadow;
  }

  .swiper-pagination-bullet {
    background: $light-prime;
    box-shadow: $card-shadow;
    opacity: .8;
  }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue